module.exports = __webpack_public_path__ + "img/ywhn.7b07408b.png";